/**
 * Segmented control (Linear-style): a labelled group of toggle buttons.
 * Extracted from MyTasksPage (spec-23d) so the operator view can reuse it for
 * the "Groepeer op" switch and the context chips. Solid white background so
 * the control reads clearly on the warm page background (spec-23d D1).
 */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string
  value: T
  options: readonly { value: T; label: string }[]
  onChange: (value: T) => void
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className="inline-flex items-center rounded-lg border border-input bg-white p-0.5"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={option.value === value}
          className={`rounded-md px-2.5 py-1 text-sm transition-colors ${
            option.value === value
              ? 'bg-muted font-medium'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
